// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function Or(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var displayText = Core__Option.getOr(props.separatorText, match.localeString.orPayUsing);
  return React.createElement("div", {
              "aria-hidden": true,
              className: "w-full w-max-[750px] relative flex flex-row my-4 "
            }, React.createElement("div", {
                  className: "OrPayUsingLine relative top-[50%] h-[1px] bg-gray-400  w-full self-center"
                }), React.createElement("div", {
                  className: "OrPayUsingLabel relative min-w-fit px-5 text-sm text-gray-400 flex justify-center"
                }, displayText), React.createElement("div", {
                  className: "OrPayUsingLine relative top-[50%] h-[1px] bg-gray-400 w-full self-center"
                }));
}

var make = Or;

export {
  make ,
}
/* react Not a pure module */
